import React, { useEffect } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import PopupMask from "@/componentsUI/PopupMask";
import { getCountryAsset } from "@/utils/countryAssetUtils";
import styles from "./DownloadGateModal.module.less";
import { openInstallLinkWithApkTransfer } from "@/features/install/apkTransfer";
import { INSTALL_TRACK_SOURCES } from "@/features/analytics/em/events";
import { trackEmEvent } from "@/features/analytics/em/sdk";
import MarketingImagePopup from "@/features/common/marketingPopup";

type Props = {
  closable?: boolean;
  installLink?: string;
};

const DownloadGateModal = NiceModal.create((props: Props) => {
  const { visible, remove, resolve } = useModal();
  const imageSrc = getCountryAsset("installBannerFacebook");

  useEffect(() => {
    if (visible) {
      trackEmEvent("apk_download_gate_view", {
        source: INSTALL_TRACK_SOURCES.DOWNLOAD_GATE_MODAL,
      });
    }
  }, [visible]);

  const closeModal = () => {
    resolve();
    remove();
  };

  const handleDownload = () => {
    trackEmEvent("apk_download_gate_click", {
      source: INSTALL_TRACK_SOURCES.DOWNLOAD_GATE_MODAL,
    });
    if (props.installLink) {
      void openInstallLinkWithApkTransfer(props.installLink, {
        source: INSTALL_TRACK_SOURCES.DOWNLOAD_GATE_MODAL,
      });
    }

    if (props.closable) {
      closeModal();
    }
  };

  if (!visible || !imageSrc) {
    return null;
  }

  return (
    <PopupMask visible={visible}>
      <MarketingImagePopup
        imageSrc={imageSrc}
        imageAlt="Download App"
        onImageClick={handleDownload}
        onClose={closeModal}
        showCloseButton={props.closable}
        imageClassName={styles.bannerImage}
      />
    </PopupMask>
  );
});

export default DownloadGateModal;
